module.exports = __webpack_public_path__ + "static/media/no-tracer.37f54f3d.svg";